import { getArrowClassName, styled, CommonStyles } from '@teko/ds-foundation';
import React, { useState, useRef, useEffect } from 'react';
import { usePopper } from 'react-popper';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    menu,
    placement = "auto",
    showArrow = false,
    trigger = "hover"
  } = _b, rest = __objRest(_b, [
    "children",
    "menu",
    "placement",
    "showArrow",
    "trigger"
  ]);
  const [show, setShow] = useState(false);
  const elementRef = useRef(null);
  const tooltipRef = useRef(null);
  const arrowRef = useRef(null);
  useEffect(() => {
    if (!show) {
      return;
    }
    function handleClickOutside(event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [elementRef, show]);
  const { styles, attributes } = usePopper(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 4]
        }
      }
    ]
  });
  return /* @__PURE__ */ React.createElement("div", {
    onMouseEnter: () => trigger === "hover" && setShow(true),
    onClick: () => {
      trigger === "click" && setShow(!show);
    },
    onMouseLeave: () => trigger === "hover" && setShow(false)
  }, /* @__PURE__ */ React.createElement("div", {
    ref: elementRef
  }, children), /* @__PURE__ */ React.createElement(DropdownMenu, __spreadValues(__spreadValues({
    show,
    ref: tooltipRef,
    style: __spreadProps(__spreadValues({}, styles.popper), { zIndex: 100 })
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ React.createElement(StyledArrow, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    "data-placement": placement,
    className: getArrowClassName(attributes) || ""
  }), menu));
};
const DropdownMenu = styled.span`
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  visibility: ${(props) => props.show ? "visible" : "hidden"};
  transition: visibility 0.3s;
  ${CommonStyles}
`;
const StyledArrow = styled.div`
  &:after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: white;
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: 3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: 3px;
  }
`;

export { Dropdown };
